import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col, Well } from 'react-bootstrap'
import MessageGroupCompany from './MessageGroupCompany'
import ChooseLockCompanyModal from '../../common/components/ChooseLockCompanyModal'
import { getMessageGroups, createCompanyGroup, removeCompanyAccesses } from './actions'

class GruppaviseringView extends Component {
    constructor(props) {
        super(props)
    }

    state = { showChooseCompanyModal: false }

    replaceMessageGroup = (group) => {
        this.setState({
            messageGroups: this.state.messageGroups.map(g => {
                if (g._id === group._id) return group

                return g
            })
        })
    }

    companyChoosen = (company) => {
        this.setState({ showChooseCompanyModal: false })
        if (!company) return

        createCompanyGroup({ companyId: company._id, lockId: this.props.lock._id }).then(t => {
            this.setState({ messageGroups: this.state.messageGroups.concat(t) })
        })
    }

    componentWillMount() {
        getMessageGroups(this.props.lock._id).then(t => {
            this.setState({ messageGroups: t.messageGroups })
        })
    }

    removeCompanyAccesses = (accessIds) => {
        removeCompanyAccesses(accessIds).then(t => {
            this.setState({
                messageGroups: this.state.messageGroups.map(group => {
                    const value = t[group._id]

                    if (value === undefined) return group // ej uppdaterad
                    if (value === null) return null // raderad

                    return value // nytt värde
                }).filter(g => !!g)
            })
        })
    }

    render() {
        const { keyedCompanies, lock } = this.props
        const { messageGroups } = this.state

        return (
            <div style={this.props.style}>
                <ChooseLockCompanyModal sendResults={this.companyChoosen} lock={lock} modalIsOpen={this.state.showChooseCompanyModal} closeModal={() => this.setState({ showChooseCompanyModal: false })} />

                <Grid style={{ maxWidth: '100%' }}>
                    <Row>
                        <Col lg={12}>
                            <Well>Gruppavisering innebär att då någon i gruppen får en leverans så får även alla andra i gruppen en avisering om leveransen.
                                Man gruppera på användare eller på företag.
                            </Well>
                            <Well>
                                När du skapar en företagsgrupp läggs alla personer med det företagsnamnet till i gruppen, både de som vid tillfället då gruppen skapas har det företagsnamnet men även alla som läggs till därefter med samma företagsnamn.
                            </Well>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={3}>
                            <span style={{ fontSize: 20 }}>Företagsgrupp</span>
                        </Col>
                        <Col lg={9} style={{ textAlign: 'left' }}>
                            <span className="qLink" onClick={() => this.setState({ showChooseCompanyModal: true })}>+ Skapa grupp</span>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={12}>
                            {!messageGroups ? 'Laddar' :
                                messageGroups.filter(g => g !== null && g.groupType === "company").map(group => {
                                    return group.companies.map((c, i) => {
                                        const company = keyedCompanies[c.company]

                                        const lockUsersForCompany = lock.users.filter((u) => u.company === company._id)

                                        return (
                                            <MessageGroupCompany key={company._id} lockUsersForCompanyCount={lockUsersForCompany.length} removeCompanyAccesses={this.removeCompanyAccesses} company={company} groupCompanyId={c._id} />
                                        )
                                    })
                                })
                            }
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        keyedCustomers: state.collectionData.keyedCustomers,
        keyedCompanies: state.collectionData.companies.keyedCompanies
    }
}

const mapDispatch = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatch)(GruppaviseringView)